export default __webpack_public_path__ + "static/media/mini-english.d7cd4996.png";